'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var plugin = require('tailwindcss/plugin');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var plugin__default = /*#__PURE__*/_interopDefaultCompat(plugin);

var typography = plugin__default.default(({ addUtilities, theme })=>{
    // NOTE: Euclid Typography components require Circular font to be enabled.
    if (!theme('fontFamily.circular')) {
        return;
    }
    const typographyTypes = {
        // HEADER - PAGE
        'h-page': {
            lg: {
                color: theme('textColor.neutral.strong'),
                fontWeight: theme('fontWeight.circular.bold'),
                fontSize: theme('fontSize.6xl'),
                lineHeight: theme('lineHeight.15')
            },
            md: {
                color: theme('textColor.neutral.strong'),
                fontWeight: theme('fontWeight.circular.black'),
                fontSize: theme('fontSize.5xl'),
                lineHeight: theme('lineHeight.12')
            },
            sm: {
                color: theme('textColor.neutral.strong'),
                fontWeight: theme('fontWeight.circular.black'),
                fontSize: theme('fontSize.3xl'),
                lineHeight: theme('lineHeight.9')
            }
        },
        // HEADER - SECTION
        'h-section': {
            lg: {
                color: theme('textColor.neutral.strong'),
                fontWeight: theme('fontWeight.circular.medium'),
                fontSize: theme('fontSize.3xl'),
                lineHeight: theme('lineHeight.9')
            },
            md: {
                color: theme('textColor.neutral.strong'),
                fontWeight: theme('fontWeight.circular.medium'),
                fontSize: theme('fontSize.2xl'),
                lineHeight: theme('lineHeight.8')
            }
        },
        // HEADER - TITLE
        'h-title': {
            lg: {
                color: theme('textColor.neutral.strong'),
                lineHeight: theme('lineHeight.7'),
                fontWeight: theme('fontWeight.circular.medium'),
                fontSize: theme('fontSize.xl')
            },
            md: {
                color: theme('textColor.neutral.strong'),
                lineHeight: theme('lineHeight.7'),
                fontWeight: theme('fontWeight.circular.bold'),
                fontSize: theme('fontSize.lg')
            }
        },
        // INTRO TEXT
        intro: {
            lg: {
                fontWeight: theme('fontWeight.circular.regular'),
                fontSize: theme('fontSize.2xl'),
                lineHeight: theme('lineHeight.8')
            },
            md: {
                fontWeight: theme('fontWeight.circular.regular'),
                fontSize: theme('fontSize.xl'),
                lineHeight: theme('lineHeight.7')
            },
            sm: {
                fontWeight: theme('fontWeight.circular.regular'),
                fontSize: theme('fontSize.lg'),
                lineHeight: theme('lineHeight.7')
            }
        },
        // LABEL
        label: {
            lg: {
                fontWeight: theme('fontWeight.circular.bold'),
                fontSize: theme('fontSize.base'),
                lineHeight: theme('lineHeight.7'),
                letterSpacing: theme('letterSpacing.wide'),
                textTransform: 'uppercase'
            },
            md: {
                fontWeight: theme('fontWeight.circular.bold'),
                fontSize: theme('fontSize.sm'),
                lineHeight: theme('lineHeight.6'),
                letterSpacing: theme('letterSpacing.wide'),
                textTransform: 'uppercase'
            },
            sm: {
                fontWeight: theme('fontWeight.circular.bold'),
                fontSize: theme('fontSize.xs'),
                lineHeight: theme('lineHeight.5'),
                letterSpacing: theme('letterSpacing.wide'),
                textTransform: 'uppercase'
            }
        },
        // BODY
        body: {
            base: {
                fontSize: theme('fontSize.base'),
                lineHeight: theme('lineHeight.6')
            },
            sm: {
                fontSize: theme('fontSize.sm'),
                lineHeight: theme('lineHeight.5')
            },
            xs: {
                fontSize: theme('fontSize.xs'),
                lineHeight: theme('lineHeight.4')
            },
            'base-bold': {
                fontWeight: theme('fontWeight.circular.bold'),
                fontSize: theme('fontSize.base'),
                lineHeight: theme('lineHeight.6')
            },
            'sm-bold': {
                fontWeight: theme('fontWeight.circular.bold'),
                fontSize: theme('fontSize.sm'),
                lineHeight: theme('lineHeight.5')
            },
            'xs-bold': {
                fontWeight: theme('fontWeight.circular.bold'),
                fontSize: theme('fontSize.xs'),
                lineHeight: theme('lineHeight.4')
            }
        }
    };
    /**
     * Nested reduce: loops through object and creates `type` utility classes.
     * @example
     * ```
     * {
     *    .type-h-page-lg: {
     *      fontFamily: "Circular, sans-serif";
     *      color: "#3D3652";
     *      fontWeight: 700;
     *      fontSize: "3.75rem";
     *      lineHeight: "3.75rem";
     *    },
     *    .type-h-page-md: {
     *      fontFamily: "Circular, sans-serif";
     *      color: "#3D3652";
     *      fontWeight: 900;
     *      fontSize: "3rem";
     *      lineHeight: "3rem";
     *    }
     *    },
     *    .type-label-md: {
     *      fontFamily: "Circular, sans-serif";
     *      fontWeight: 700;
     *      fontSize: "0.875rem";
     *      lineHeight: "1.25rem";
     *    },
     *    ...
     * }
     * ```
     */ const typographyUtilityClasses = Object.entries(typographyTypes).reduce((typesAcc, [typeName, variants])=>{
        const classes = Object.entries(variants).reduce((variantAcc, [variantName, styles])=>{
            return {
                ...variantAcc,
                [`.type-${typeName}-${variantName}`]: {
                    fontFamily: theme(`fontFamily.circular`),
                    ...styles
                }
            };
        }, {});
        return {
            ...typesAcc,
            ...classes
        };
    }, {});
    addUtilities(typographyUtilityClasses);
});

exports.default = typography;
//# sourceMappingURL=typography.js.map
